import { useQuery } from '@tanstack/react-query';
import { getDemoOrInfraMapData } from 'services/reactQueryservices';
import { demoOrInfraMapDataKey } from 'react_query/query-keys';

const useDemoOrInfraDataForMap = (type: string, locationType: string, projectId: number) => {
    const { data, isFetching, error } = useQuery({
        queryKey: [demoOrInfraMapDataKey, type, locationType, projectId],
        queryFn: () => getDemoOrInfraMapData(type, locationType, projectId),
        enabled: !!type && type === 'infra'
    });

    return {
        data,
        isFetching,
        error
    };
}

export default useDemoOrInfraDataForMap